import { motion } from "framer-motion";

export default function FullScreenLoader() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] flex items-center justify-center z-[9999]">
      
      <div className="flex flex-col items-center gap-8">
        
        {/* Animated Logo Circle */}
        {/* <motion.div
          className="w-20 h-20 rounded-2xl bg-gradient-to-r from-[#862b2b] to-[#a53a3a] flex items-center justify-center shadow-2xl"
          animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 5, -5, 0],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <span className="text-white text-2xl font-bold tracking-wider">
            SG
          </span>
        </motion.div> */}
{/* Animated Logo Image */}


        {/* Animated Spinner Ring */}
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full border-4 border-white/10"></div>
          <motion.div
            className="absolute inset-0 rounded-full border-4 border-t-[#862b2b] border-r-[#a53a3a]"
            animate={{ rotate: 360 }}
            transition={{
              repeat: Infinity,
              duration: 1.2,
              ease: "linear",
            }}
          />
        </div>



        {/* Loading Text */}
        <motion.p
          className="text-slate-300 text-sm tracking-widest uppercase"
          initial={{ opacity: 0 }}
          animate={{ opacity: [0.4, 1, 0.4] }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
          }}
        >
          Preparing your workspace...
        </motion.p>
      </div>
    </div>
  );
}